import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default Helper.extend({
  abilities: service(),

  compute([lineItem]) {
    return (
      this.abilities.hasAbility('edit_all_transactions') ||
      (this.abilities.hasAbility('edit_manual_transactions') &&
        lineItem.isManual)
    );
  },
});
